import { api } from "@/api/client";
import { unwrap } from "@/api/errors";

export type ExportFormat = "markdown" | "pdf" | "json" | "text";

/** POST /v1/chat/conversations/{id}/export — returns the file as a Blob. */
export async function exportConversation(id: string, format: ExportFormat): Promise<Blob> {
  return unwrap(
    await api.POST("/v1/chat/conversations/{id}/export", {
      params: { path: { id } },
      body: { format },
      parseAs: "blob",
    }),
  );
}
